module.exports = __webpack_public_path__ + "media/3.701ada30.wav";